class ConsumerOrdersController  {
    constructor(createAutoQuery) {
        let options = {
            url: 'QueryCarts.json?StatusNotEqualTo=Cart&PurchaserId=' + this.consumerId,
            pageSize: 24,
            orderBy:'-Id',
            append:false,
            autoLoad:true,
            sortOptions:{
                'Id': 'Order #: Low to High',
                '-Id': 'Order #: High to Low',
                'Status': 'Status: A to Z',
                '-Status': 'Status: Z to A',
                'OrderDate': 'Date: Newest',
                '-OrderDate': 'Date: Oldest',
                'OrderTotal': 'Amount: Low to High',
                '-OrderTotal': 'Amount: High to Low',
            }
        };
        if (!this.consumerId) {
            options.url = 'QueryOrders.json?StatusNotEqualTo=Cart';
        }
        this.query = createAutoQuery(options);
    }
    load(){return this.query.load.apply(this.query, arguments);}

    $onDestroy() {
        this.query.dispose();
    }
}

class ConsumerOrders{
    constructor(){
        this.bindings= {
            consumerId: '@'
        };
        this.controller = ConsumerOrdersController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'consumer-orders.html'
    }
}

export default  ConsumerOrders;

angular.module('emun.consumer').component('consumerOrders', new ConsumerOrders());